import { createContext } from 'react';
export function createEmptyContext() {
    return createContext({});
}
//# sourceMappingURL=create-empty-context.js.map